import React, { useEffect, useState } from "react";
import { createCanvas, loadImage } from "canvas";

import {
  Skeleton,
  Upload,
  Select,
  // Tag,
  Button,
  // Row,
  // Col,
  // Checkbox,
} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "moment-timezone";
// import QRCode from "qrcode";
import PolygonMapComponent from "../../components/PolygonMapComponent";
import PDFComponent from "../../components/PDFComponent";
// import ArrowComponent from "../components/ArrowComponent";
// // import { useAuth } from "../../context/AuthContext";
// import config from "../config.json";
import { InboxOutlined } from "@ant-design/icons";
import DependenciesComponent from "../../components/DependenciesComponent";
import {useAxios} from "../../hooks/hooks";
import config from "../../business/config.json"
import { Buffer } from 'buffer';


const { Dragger } = Upload;

const COL = " & ";
const LATEX = "$LATEX.";
const INSPECTED_AREAS_TEMPLATE =
  "\\begin{itemize} " + "$$ROWS" + "\\end{itemize} ";
const SUMMARY_POSITIVE_TEMPLATE =
  "\\paragraph{$$MATERIAL}~\\\\ The following was identified or presumed present within the building at the time of the inspection:" +
  "\\begin{longtable}[l]{|" +
  ">{\\footnotesize\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\footnotesize\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\footnotesize\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\footnotesize\\raggedright\\arraybackslash}p{0.6\\textwidth}|" +
  "} " +
  "\\hline " +
  "\\bf{Location} & \\bf{Material} & \\bf{Risk Score} & \\bf{Recommendation} \\\\ " +
  "\\hline " +
  "\\endfirsthead " +
  "\\hline " +
  "\\bf{Location} & \\bf{Material} & \\bf{Risk Score} & \\bf{Recommendation} \\\\ " +
  "\\hline " +
  "\\endhead " +
  "\\hline " +
  "\\endfoot " +
  "\\hline " +
  "\\endlastfoot " +
  "$$ROWS" +
  "\\end{longtable} ";
const SUMMARY_NEGATIVE_TEMPLATE =
  "\\paragraph{$$MATERIAL}~\\\\ " +
  "No $$MATERIAL was identified within the building at the time of the inspection. ";
const RESULTS_FRAME =
  "{\\footnotesize\\begin{longtable}[l]{|" +
  ">{\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\raggedright\\arraybackslash}p{0.1\\textwidth}|" +
  ">{\\raggedright\\arraybackslash}p{0.6\\textwidth}|" +
  "} " +
  "\\caption{\\normalsize Hazardous Materials}\\\\" +
  "\\hline " +
  "\\bf{Location} & \\bf{Material} & \\bf{Risk Score} & \\bf{Recommendation} \\\\ " +
  "\\hline " +
  "\\endfirsthead " +
  "\\hline " +
  "\\bf{Location} & \\bf{Material} & \\bf{Risk Score} & \\bf{Recommendation} \\\\ " +
  "\\hline " +
  "\\endhead " +
  "$$ROWS" +
  "\\end{longtable}} ";
const RESULTS_POSITIVE_TEMPLATE =
  "\\multicolumn{4}{|l|}{\\bf{$$MATERIAL}} \\\\ " + "\\hline " + "$$ROWS";
const RECOMMENDATIONS_POSITIVE_TEMPLATE =
  //"\\paragraph{} "+
  //"\\paragraph{$$MATERIAL} "+
  "\\begin{table}[!ht] " +
  "\\textbf{$$MATERIAL} " +
  "\\footnotesize " +
  "\\caption{\\normalsize Recommendations for $$MATERIAL} " +
  "\\begin{tabularx}{\\textwidth}{|" +
  ">{\\raggedright\\arraybackslash}p{0.2\\textwidth}|" +
  "X|" +
  "} " +
  "\\hline " +
  "\\bf{Risk} & \\bf{Recommendation} \\\\ " +
  "\\hline " +
  "$$ROWS" +
  "\\end{tabularx}" +
  "\\end{table} ";
const FIGURE_TEMPLATE =
  "\\begin{figure}[!ht] " +
  "\\centering " +
  "\\caption{$$CAPTION} " +
  "\\includegraphics[width=\\textwidth, height=10cm, keepaspectratio]{$$FILENAME} " +
  "\\end{figure} ";
const REGISTER_TEMPLATE = "\\hline " + "$$ROW " + "\\cr ";

const PAGE_SIZE = 100;

const fetchPage = async (axios, path, baseQuery, page) => {
  const sep = baseQuery ? "&" : "";
  const url = `${path}/?${baseQuery}${sep}page_size=${PAGE_SIZE}&page=${page}`;
  const response = await axios.current.get(url);
  return response.data;
};

export const fetchPaginatedFirstPage = async (axios, path, baseQuery = "") => {
  try {
    const data = await fetchPage(axios, path, baseQuery, 1);
    return {
      rows: data.rows,
      total_rows: data.total_rows,
      hasMore: data.rows.length < data.total_rows,
      path,
      baseQuery,
    };
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const loadAllPages = async (axios, paginated) => {
  if (!paginated || !paginated.hasMore) return paginated;
  const totalPages = Math.ceil(paginated.total_rows / PAGE_SIZE);
  const requests = [];
  for (let p = 2; p <= totalPages; p++) {
    requests.push(fetchPage(axios, paginated.path, paginated.baseQuery, p));
  }
  const pages = await Promise.all(requests);
  const allRows = paginated.rows.slice();
  pages.forEach((d) => allRows.push(...d.rows));
  return { ...paginated, rows: allRows, hasMore: false };
};

export const getMaterials = (axios) =>
  fetchPaginatedFirstPage(axios, "/materials-list");

export const getBibliography = (axios) =>
  fetchPaginatedFirstPage(axios, "/references-list");

export const getReportView = (axios, id_project) => {
  const orderBy = [
    "internal_external",
    "building",
    "level",
    "room",
    "type_of_hazmat",
    "id_view_report",
  ];
  let query = "";
  orderBy.forEach((col, i) => {
    query += `order[${i}]=${col}&`;
  });
  query += `filter[id_project]=${id_project}`;
  return fetchPaginatedFirstPage(axios, "/report-view", query);
};

export const getRecommendationsView = (axios, id_project) =>
  fetchPaginatedFirstPage(
    axios,
    "/recommendations-view",
    `filter[id_project]=${id_project}`
  );

export const getRoomView = (axios, id_project) =>
  fetchPaginatedFirstPage(
    axios,
    "/room-view",
    `filter[id_project]=${id_project}`
  );

export const getProject = async (axios, id_project) => {
  console.log("get project")
  try {
    const response = await axios.current.get("/project-view/" + id_project);
    console.log(response)
    return response.data[0];
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getExecutiveChart = async (axios, id_project) => {
  try {
    const response = await axios.current.get("/charts/" + id_project);
    return response.data.imagedata;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const buildDoc = async (axios, project, materials, reportView, recommendationsView, executiveChart, pdfAttachments) => {
    console.log("generating report")
    var attachments = [];
    var inspectedareas = "";
    var projectaddress = "";
    projectaddress += project.street_project;
    projectaddress += project.suburb_project
      ? " " + project.suburb_project
      : "";
    projectaddress += project.city_project ? " " + project.city_project : "";
    projectaddress += " " + project.short_name_region;
    projectaddress += " " + project.postcode_project;
    projectaddress += " Australia";
    if (projectaddress.charAt(0) === " ")
      projectaddress = projectaddress.substring(1);
    var jobnumber = project.xero_project + "-01-" + project.ID;
    var reportid = "ADE-" + project.ID + "-" + project.place_project;
    var reportdate = moment(project.report_date_project).format("DD.MM.YYYY");

    var parentid = "ADE-" + project.parent_project;
    var parentdate = project.parent_project_date;

    var inspectiondate = moment(project.inspection_date_project).format(
      "DD.MM.YYYY"
    );
    var reinspectiondate = moment(project.inspection_date_project)
      .add(5, "years")
      .format("DD.MM.YYYY");
    var mapdate = project.map_date_project
      ? moment(project.map_date_project).format("DD.MM.YYYY")
      : reportdate;
    var builddate = project.build_date_project + "";
    var reportauthor =
      project.first_name_author + " " + project.last_name_author;
    var inspector =
      project.first_name_inspector + " " + project.last_name_inspector;
    var reviewer =
      project.first_name_reviewer + " " + project.last_name_reviewer;
    var laaauthor = sanitizeLatex(project.laa_diploma_author);
    var laainspector = sanitizeLatex(project.laa_diploma_inspector);
    var laareviewer = sanitizeLatex(project.laa_diploma_reviewer);
    var mapimage = encodeURI(PolygonMapComponent.type.getStaticMapURL(project));
    attachments.push({
      filename: "map.jpg",
      type: "url",
      contents: mapimage,
    });
    var summaryofresults = LATEX;
    var resultstable = "";
    var hazmatregister = LATEX;
    var projectphotographs = LATEX;
    var recommendations = LATEX;
    var pdfs = JSON.parse(JSON.stringify(pdfAttachments));
    var projectattachments = LATEX;
    pdfs.forEach(function (p, q) {
      projectattachments += "\\includepdf[pages=-]{" + p + "}";
      attachments.push({
        type: "local",
        filename: p,
        content: p,
      });
    });

    var inspected_areas = "";
    project.buildings.forEach(function (b) {
      inspected_areas += "\\item " + b.name + " ";
      b.levels.forEach(function (l) {
        inspected_areas += "\\begin{itemize} ";
        inspected_areas += "\\item " + l.name + " ";
        //inspected_areas +="\\begin{itemize} ";
        //inspected_areas +="\\item "+l.rooms.join()+" ";
        //inspected_areas +="\\end{itemize} ";
        inspected_areas += "\\end{itemize} ";
      });
    });
    inspectedareas += INSPECTED_AREAS_TEMPLATE.replace(
      "$$ROWS",
      inspected_areas
    );
    var materials_summary = {};
    materials.forEach(function (m) {
      materials_summary[m.name_material] = [];
    });
    var photos = {};
    var len = reportView.length;
    for (var a = 0; a < len; a++) {
      var r = reportView[a];
      //HAZMAT REGISTER
      var internal_external = sanitizeLatex(r.internal_external);
      var building = sanitizeLatex(r.building);
      var level = sanitizeLatex(r.level);
      var room = sanitizeLatex(r.room);
      var material_type_description = sanitizeLatex(
        r.material_type_description
      );
      var control_recommendations = sanitizeLatex(r.control_recommendations);
      var register_row = [
        internal_external,
        building,
        level,
        room,
        material_type_description,
        r.type_of_hazmat,
        r.quantity,
        r.unit,
        r.photo_number,
        r.sample_number,
        r.analytical_results,
        r.friability,
        r.accessibility,
        r.condition,
        "\\cellcolor[HTML]{" + r.color_flag.substring(1) + "}" + r.risk_score,
        control_recommendations,
        r.review_date === "N/A"
          ? r.review_date
          : moment(r.review_date).format("YYYY.MM.DD"),
      ].join(COL);
      hazmatregister += REGISTER_TEMPLATE.replace("$$ROW", register_row);
      //SUMMARY AND RESULTS
      if (
        (r.risk_score !== "Negligible" ||
          r.type_of_hazmat === "Inaccessible Areas") &&
        r.control_recommendations != null &&
        r.control_recommendations.length !== 0
      ) {
        materials_summary[r.type_of_hazmat].push(r);
      }
      //PHOTOS
      if (r.url_photo === null) continue;
      var url = await generateArrowImageURL(
        axios,
        600,
        400,
        r.x_event,
        r.y_event,
        r.angle_event,
        r.color_flag,
        r.url_photo
      );
      var filename = "photo_" + r.photo_number + ".jpg";
      attachments.push({
        filename: filename,
        type: "image64",
        contents: url,
      });
      var caption = sanitizeLatex(r.caption);
      projectphotographs += FIGURE_TEMPLATE.replace(
        "$$FILENAME",
        filename
      ).replace("$$CAPTION", caption);
    }
    //SUMMARY AND RESULTS
    const risk_order = {
      Negligible: 1,
      Low: 2,
      Medium: 3,
      High: 4,
      Unknown: 5,
    };
    for (var m in materials_summary) {
      var bundle = materials_summary[m];
      if (bundle.length === 0) {
        summaryofresults += SUMMARY_NEGATIVE_TEMPLATE.replace(
          /\$\$MATERIAL/g,
          m
        );
        continue;
      }
      var rows = "";
      bundle
        .sort((x, y) => risk_order[y.risk_score] - risk_order[x.risk_score])
        .forEach(function (b) {
          var loc = sanitizeLatex(b.location);
          var control_recommendations = sanitizeLatex(
            b.control_recommendations
          );
          var material_type_description = sanitizeLatex(
            b.material_type_description
          );
          rows +=
            [
              loc,
              material_type_description,
              "\\cellcolor[HTML]{" +
                b.color_flag.substring(1) +
                "}" +
                b.risk_score,
              control_recommendations,
            ].join(COL) + " \\\\ \\hline ";
        });
      //SUMMARY
      summaryofresults += SUMMARY_POSITIVE_TEMPLATE.replace(
        /\$\$MATERIAL/g,
        m
      ).replace("$$ROWS", rows);
      //RESULTS
      resultstable += RESULTS_POSITIVE_TEMPLATE.replace(
        /\$\$MATERIAL/g,
        m
      ).replace("$$ROWS", rows);
    }
    resultstable = LATEX + RESULTS_FRAME.replace("$$ROWS", resultstable);
    //RECOMMENDATIONS
    var materials_recommendation = {};
    recommendationsView.forEach(function (r) {
      if (undefined === materials_recommendation[r.type]) {
        materials_recommendation[r.type] = [];
      }
      materials_recommendation[r.type].push(r);
    });
    for (var n in materials_recommendation) {
      var bundle = materials_recommendation[n];
      var rows = "";
      bundle
        .sort((x, y) => risk_order[y.risk_score] - risk_order[x.risk_score])
        .forEach(function (b) {
          if (
            b.control_recommendations === null ||
            b.control_recommendations === ""
          )
            return;
          var control_recommendations = sanitizeLatex(
            b.control_recommendations
          );
          rows +=
            [
              "\\cellcolor[HTML]{" +
                b.color_flag.substring(1) +
                "}" +
                b.risk_score,
              control_recommendations,
            ].join(COL) + " \\\\ \\hline ";
        });
      recommendations += RECOMMENDATIONS_POSITIVE_TEMPLATE.replace(
        /\$\$MATERIAL/g,
        n
      ).replace("$$ROWS", rows);
    }
    //CHART
    attachments.push({
      filename: "executivechart.png",
      type: "image64",
      contents: executiveChart,
    });
    var doc = {
      projectaddress,
      projectsite: project.place_project,
      companyname: project.name_company,
      client:
        project.first_name_customer +
        " " +
        project.last_name_customer +
        " (" +
        project.name_company +
        ")",
      jobnumber,
      reportid,
      reportdate,
      parentid,
      parentdate,
      inspectiondate,
      reportauthor,
      inspector,
      reviewer,
      projectdescription: project.description_project,
      mapprovider: project.name_company_map,
      mapdate,
      mapimage,
      summaryofresults,
      resultstable,
      recommendations,
      hazmatregister,
      projectphotographs,
      projectattachments,
      attachments,
      reinspectiondate,
      builddate,
      laaauthor,
      laareviewer,
      laainspector,
      bibliography: "",
        inspectedareas

    };
    return doc;
};

export const generateReport = async (axios, project, doc) => {
    console.log("generating report")
    try {
      console.log("about to post: ")
      console.log(doc)
      const hazmat_response = await axios.current.post(
        "/doc/hazmat/project/" + project.ID,
        doc
      );
      doc.attachments.push({
        filename: "hazmat.pdf",
        type: "url",
        contents: config.api_domain +
          "/business/database/project/latex/hazmat/" +
          project.ID +
          "/document.pdf",
      });
      const report_type = project.short_name_category;
      const report_response = await axios.current.post(
        "/doc/" + report_type + "/project/" + project.ID,
        doc
      );
    } catch (e) {
      console.error(e);
      return null;
    }
};
const sanitizeLatex = (text) => {
    var output = (text || "")
        .replace(/#/g, "\\#")
        .replace(/%/g, "\\%")
        .replace(/&/g, "\\&")
        .replace(/_/g, "\\_");
    return output;
};

const generateArrowImageURL = async (
    axios,
    w,
    h,
    arrow_x,
    arrow_y,
    arrow_angle,
    color,
    src,
    callback
) => {
    var CANVAS_WIDTH = 600;
    var CANVAS_HEIGHT = 400;
    var ICON_SIZE = 36;
    var ARROW_SCALE = 0.08;
    var radians = arrow_angle * (Math.PI / 180);
    var x = (arrow_x / 100) * (CANVAS_WIDTH - ICON_SIZE);
    var y = (arrow_y / 100) * (CANVAS_HEIGHT - ICON_SIZE);
    x = x > CANVAS_WIDTH - ICON_SIZE ? CANVAS_WIDTH - ICON_SIZE : x;
    y = y > CANVAS_HEIGHT - ICON_SIZE ? CANVAS_HEIGHT - ICON_SIZE : y;
    //ARROW
    var arrow = new Path2D(
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    );
    arrow.closePath();
    var arrow_canvas = createCanvas(ICON_SIZE, ICON_SIZE);
    var arrow_context = arrow_canvas.getContext("2d");
    arrow_context.translate(0, -3); //Calibration
    arrow_context.scale(ARROW_SCALE, ARROW_SCALE);
    arrow_context.fillStyle = color;
    arrow_context.fill(arrow);
    arrow_context.lineWidth = 15;
    arrow_context.strokeStyle = "#000000";
    arrow_context.stroke(arrow);
    var arrow_url = arrow_canvas.toDataURL("image/png", 1);
    var arrow_image = await loadImage(arrow_url);
    //IMAGE
    var response = await axios.current.get(src, { responseType: "arraybuffer" });
    var base64 =
        "data:image/jpeg;base64," + Buffer.from(response.data, "binary").toString("base64");
    var image = await loadImage(base64);
    var image_width = image.width;
    var image_height = 2 * (image.width / 3);
    var image_vertical_offset = (image.height - image_height) / 2;
    var canvas = createCanvas(CANVAS_WIDTH, CANVAS_HEIGHT);
    var context = canvas.getContext("2d");
    context.drawImage(
        image,
        0,
        image_vertical_offset,
        image_width,
        image_height,
        0,
        0,
        CANVAS_WIDTH,
        CANVAS_HEIGHT
    );
    context.translate(8, 2); //Calibration
    context.translate(x + ICON_SIZE / 2, y + ICON_SIZE / 2);
    context.rotate(radians);
    context.translate(-(x + ICON_SIZE / 2), -(y + ICON_SIZE / 2));
    context.drawImage(arrow_image, x, y);
    var url = canvas.toDataURL("image/jpeg", 1);
    return url;
};
function ReportPage(props) {
  const axios = useAxios();
  const [loaded, setLoaded] = useState(false);
  const [project, setProject] = useState({});
  const [reportView, setReportView] = useState(null);
  const [recommendationsView, setRecommendationsView] = useState(null);
  const [bibliography, setBibliography] = useState(null);
  const [materials, setMaterials] = useState(null);
  const [pdfAttachments, setPdfAttachments] = useState([]);
  const [map, setMap] = useState(null);
  const [executiveChart, setExecutiveChart] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState("A");


  const draggerProps = {
    name: "file",
    multiple: true,
    action: config.api_domain + "/attachments",
    accept: ".pdf",
    onChange(info) {
      const { status } = info.file;
      switch (status) {
        case "uploading":
          break;
        case "done":
          var pdfs = JSON.parse(JSON.stringify(pdfAttachments));
          pdfs.push(info.file.response.filename);
          setPdfAttachments(pdfs);
          break;
        case "error":
          break;
        default:
        //nothing
      }
    },
  };




  const buildDocInternal = async () => {
    console.log("generating report")
    setLoaded(false);
    const [fullMaterials, fullReportView, fullRecommendations, fullBibliography] = await Promise.all([
      loadAllPages(axios, materials),
      loadAllPages(axios, reportView),
      loadAllPages(axios, recommendationsView),
      loadAllPages(axios, bibliography),
    ]);
    var bibOutput = "";
    fullBibliography.rows.forEach(function (z) {
      bibOutput += "@book{" + z.code_bibliography + ",\n";
      bibOutput += '\tauthor = "{' + z.author_bibliography + '}",\n';
      bibOutput += '\ttitle = "' + z.title_bibliography + '",\n';
      bibOutput += '\tyear = "' + z.year_bibliography + '"\n';
      bibOutput += "}\n\n";
    });
    var doc = await buildDoc(
      axios,
      project,
      fullMaterials.rows,
      fullReportView.rows,
      fullRecommendations.rows,
      executiveChart,
      pdfAttachments
    );
    doc.bibliography = bibOutput;
    return doc;
  };

  const generateSpecificReport = async () => {
    console.log("generating specific report")
    setLoaded(false);
    const doc = await buildDocInternal();
    if (!doc) return;

    try {
      const report_type = selectedReportType.toLowerCase();
      await axios.current.post(
        "/doc/" + report_type + "/project/" + project.ID,
        doc
      );
      const link = document.createElement("a");
      link.href = config.api_domain + "/business/database/project/latex/" + report_type + "/" + project.ID + "/document.pdf";
      link.download = "report.pdf";
      link.click();
    } catch (e) {
      console.error(e);
    }
    setPdfAttachments([]);
    setLoaded(true);
  };


  const generateReportInternal = async () => {
    console.log("generating report")
    setLoaded(false);
    const doc = await buildDocInternal();
    if (!doc) return;

    await generateReport(axios, project, doc);
    setPdfAttachments([]);
    setLoaded(true);
  };
  useEffect(() => {var id_project = props.id || props.match.params.id;
      console.log(id_project)
      Promise.all([
          getProject(axios,id_project),
          getReportView(axios,id_project),
          getRecommendationsView(axios, id_project),
          getBibliography(axios),
          getMaterials(axios),
          getExecutiveChart(axios,id_project),
      ]).then((v) =>
      {
          console.log("here")
          console.log(v)
          var p = v[0];
          var rep = v[1];
          var rec = v[2];
          var b = v[3];
          var m = v[4];
          var ex = v[5];
          if (
              undefined === p ||
              undefined === rep ||
              undefined === rec ||
              undefined === b ||
              undefined === m ||
              undefined === ex
          ) {
              setLoaded(true);
              return;
          }
          setExecutiveChart(ex);
          p.short_name_category = p.short_name_category.toLowerCase();
          setProject(p);
          setReportView(rep);
          setRecommendationsView(rec);
          setBibliography(b);
          var map_object = {
              polygon: p.polygon_project,
              latitude: p.latitude_project,
              longitude: p.longitude_project,
              address: p.street_project,
              city: p.city_project,
              region: p.id_region,
              postcode: p.postcode_project,
              map_zoom: p.map_zoom_project,
          };
          setMaterials(m);
          setMap(map_object);
          setLoaded(true);
      });
  }, [props.match, props.id]);

  if (loaded === false)
    return (
      <>
        <Skeleton />
      </>
    );

  if (loaded === true)
    return (
      <DependenciesComponent
        mode="block"
        dependencies={[
          "project-view",
          "risk-matrix",
          "events",
          "materials-list",
          "references-list",
        ]}
        {...props}
      >
        <PageHeader
          title={
            <>
              <span>Report</span>&nbsp;
            </>
          }
          style={{ padding: 0, paddingBottom: 16 }}
          extra={[]}
        />
        <PDFComponent
          file={
            "/business/database/project/latex/hazmat/" +
            project.ID +
            "/document.pdf"
          }
        />
        <PDFComponent
          file={
            "/business/database/project/latex/" +
            project.short_name_category +
            "/" +
            project.ID +
            "/document.pdf"
          }
        />
        <Dragger {...draggerProps}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag attachments to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. PDF files only.
          </p>
        </Dragger>
        <div
          style={{
            padding: "16px",
            paddingLeft: 0,
            paddingRight: 0,
            textAlign: "right",
          }}
        >
          <Select
            value={selectedReportType}
            style={{ width: 120, marginRight: 8, textAlign: 'left' }}
            onChange={(value) => setSelectedReportType(value)}
          >
            <Select.Option value="HMSR">Hazardous Building Materials Survey Report</Select.Option>
            <Select.Option value="PDHMS">Pre-Demolition Hazardous Materials Survey</Select.Option>
            <Select.Option value="TAMIR">Targeted Asbestos Materials Inspection Report</Select.Option>
            <Select.Option value="hmsrc">Hazardous Building Materials Survey Report (University of Canberra)</Select.Option>
            <Select.Option value="test">Test Report</Select.Option>
            <Select.Option value="hmsrsam">Hazardous Building Materials Survey Report (Samaritans)</Select.Option>
            <Select.Option value="hmsrcsam">Hazardous Building Materials Survey Report (Samaritans) (Updated)</Select.Option>
            <Select.Option value="hmsrrsl">Hazardous Building Materials Survey Report (RSL LifeCare)</Select.Option>
            <Select.Option value="HMSRV">Hazardous Building Materials Survey Report (Victoria)</Select.Option>
            <Select.Option value="HMSRQ">Hazardous Building Materials Survey Report (Queensland)</Select.Option>
            <Select.Option value="PDHMSV">Pre-Demolition Hazardous Materials Survey (Victoria)</Select.Option>
            <Select.Option value="PDHMSQ">Pre-Demolition Hazardous Materials Survey (Queensland)</Select.Option>
          </Select>
          <Button key="button-2" onClick={generateSpecificReport} style={{ marginRight: 8 }}>
            <FontAwesomeIcon icon="sync" className="fa-fw" />
            &nbsp; Generate this report Type
          </Button>
          <Button key="button-1" onClick={generateReportInternal}>
            <FontAwesomeIcon icon="sync" className="fa-fw" />
            &nbsp; Build Report
          </Button>
        </div>
      </DependenciesComponent>
    );
}

export default ReportPage;
